import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'maxCharacters',
    pure: false  // Marcar el pipe como impuro para que se actualice en eventos externos
})
export class MaxCharactersPipe implements PipeTransform {
  private currentWidth: number = 0;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.currentWidth = window.innerWidth;
      window.addEventListener('resize', this.onResize.bind(this));
    }
  }

  transform(value: string, defaultLimit: number | null, breakpointLimits?: { [key: string]: number }): string {
    if (!value) return value;

    !defaultLimit && (defaultLimit = Infinity);

    if (breakpointLimits) {
      defaultLimit = this.getLimitForCurrentWidth(breakpointLimits, defaultLimit);
    } 
    
    if (value.length > defaultLimit) {
      const shortWord = value.substring(0, defaultLimit);
      const words = shortWord.split(" ");
      if (words.length > 1) {
        const fixedWord = words.slice(0, -1).join(" ") + "...";
        return fixedWord;
      } else if (words.length === 1) {
        return shortWord + "...";
      }
    }
    return value;
  }

  private onResize() {
    if(isPlatformBrowser(this.platformId)){
      this.currentWidth = window.innerWidth;
    }
  }

  private getLimitForCurrentWidth(breakpointLimits: { [key: string]: number }, defaultLimit: number): number {
    const resolutionRanges = {
      'xs': [0, 576.98],
      'sm': [576.98, 767.98],
      'md': [767.98, 991.98],
      'lg': [991.98, 1199.98],
      'xl': [1199.98, 1399.98],
      'xxl': [1399.98, Infinity]
    };

    for (let breakpoint in breakpointLimits) {
      const [min, max] = resolutionRanges[breakpoint];
      if (this.currentWidth >= min && this.currentWidth <= max) {
        return breakpointLimits[breakpoint];
      }
    }

    // Return the default limit if no breakpoint matches
    return defaultLimit;
  }
}
